import React, { useMemo, type JSX } from 'react';

import { ContentField, Typography } from '@/shared/ui';

import { UserRequestsTab } from '../model';

interface Props {
  tab: UserRequestsTab;
}

export const UserRequestsEmptyListMessage: React.FC<Props> = ({ tab }) => {
  const text = useMemo<JSX.Element>(() => {
    switch (tab) {
      case 'active':
        return (
          <>
            Наразі у вас немає активних запитів. <br /> Коли ви замовите послугу, вона зʼявиться тут.
          </>
        );

      case 'archive':
        return (
          <>
            Наразі у вас немає архівованих запитів. <br /> Тут будуть зберігатись ваші опрацьовані запити.
          </>
        );

      case 'draft':
        return (
          <>
            Наразі у вас немає чернеток. <br /> Коли ви створите чернетку, вона зʼявиться тут. <br /> Зверніть увагу,
            чернетка зберігається протягом 14 днів, після чого автоматично видаляється.
          </>
        );

      default:
        return <React.Fragment />;
    }
  }, [tab]);

  return (
    <ContentField
      icon="hi"
      content={
        <Typography color="graphite" textCenter>
          {text}
        </Typography>
      }
    />
  );
};
